import * as Yup from "yup";
import translate from "i18n/translate";
import translateIntl from "i18n/translateIntl";
import {
  IOS,
  SHOPIFY,
  NEW_SHOPIFY,
  ECOMMERCE,
  ANDROID,
} from "../../../../../constants";

export const buttonOptions = [ECOMMERCE, IOS, ANDROID, SHOPIFY];

export const intialFormOptions = {
  [ECOMMERCE]: {
    platform: ECOMMERCE,
    applicationName: "",
  },
  [IOS]: {
    platform: IOS,
    applicationName: "",
    applicationBundle: "",
  },
  [ANDROID]: {
    platform: ANDROID,
    applicationName: "",
    applicationBundle: "",
  },
  [SHOPIFY]: {
    platform: SHOPIFY,
    applicationName: "",
  },
  [NEW_SHOPIFY]: {
    platform: NEW_SHOPIFY,
    applicationName: "",
  },
};

export const getPlatformId = (value) =>
  ({
    [ECOMMERCE]: 1,
    [ANDROID]: 2,
    [IOS]: 3,
    [SHOPIFY]: 4,
    [NEW_SHOPIFY]: 5,
  }?.[value]);

export const validDays = ["1", "2", "3"];

export const inputShouldBeRendered = (key) => {
  if (
    key === "platform" ||
    key === "valid" ||
    key === "oxxo" ||
    key === "msi"
  ) {
    return false;
  }
  return true;
};

export const getFormValidationScheme = (type, editMode) => {
  const applicationName = Yup.string().required(
    translate("common.requiredField")
  );

  const applicationBundle = Yup.string()
    .required(translate("common.requiredField"))
    .matches(
      /^[a-zA-Z-](([a-zA-Z0-9-])+)?(\.[a-zA-Z-](([a-zA-Z0-9-])+)?){0,}$/,
      translateIntl("common.errors.matches")
    );

  const url =
    editMode &&
    Yup.string()
      .url(translate("common.entry.url"))
      .required(translate("common.requiredField"));

  const terms = editMode && Yup.string().url(translate("common.entry.url"));

  switch (type) {
    case ECOMMERCE:
      return Yup.object().shape({
        applicationName,
        url,
      });
    case SHOPIFY:
      return Yup.object().shape({
        applicationName,
        terms,
        valid:
          editMode &&
          Yup.number().when("oxxo", {
            is: true,
            then: (schema) =>
              schema
                .required(translate("common.requiredField"))
                .min(1, translate("common.requiredField")),
          }),
      });
    case NEW_SHOPIFY:
      return Yup.object().shape({
        applicationName,
        terms,
        valid:
          editMode &&
          Yup.number().when("oxxo", {
            is: true,
            then: (schema) =>
              schema
                .required(translate("common.requiredField"))
                .min(1, translate("common.requiredField")),
          }),
      });
    case IOS:
      return Yup.object().shape({
        applicationName,
        applicationBundle,
        url,
      });
    case ANDROID:
      return Yup.object().shape({
        applicationName,
        applicationBundle,
        url,
      });
    default:
      return Yup.object().shape({});
  }
};
